import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  errorMessage = signal<string | null>(null);
  counter = signal<number>(100);
  private intervalId: any;

  handleError(message: string) {
    this.errorMessage.set(message);
    this.startCountDown();
  }

  clearError() {
    this.errorMessage.set(null);
  }

  private startCountDown() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.counter.set(100);
    this.intervalId = setInterval(() => {
      const currentValue = this.counter();
      if (currentValue > 0) {
        this.counter.set(currentValue - 1);
      } else {
        this.clearError();
        clearInterval(this.intervalId);
      }
    }, 40);
  }
}
